var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isShowAdvanced)?_c('el-tooltip',{attrs:{"effect":"dark","content":"Delete bot","placement":"bottom"}},[_c('el-button',{staticClass:"hidden-sm-and-down",attrs:{"circle":"","size":"small","type":"danger","loading":_vm.deleting,"plain":true,"icon":"el-icon-delete"},on:{"click":_vm.deleteBot}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }